import Component from '@glimmer/component';
import { localCopy } from 'tracked-toolbox';

export interface UiLabelSignature {
  Args: {
    for?: string | null;
    required?: boolean;
    isReadonly?: boolean;
    text?: string | null;
    errors?: string[] | string | null;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLLabelElement;
}

export default class UiLabel extends Component<UiLabelSignature> {
  @localCopy('args.required', false) required!: boolean;
  @localCopy('args.isReadonly', false) isReadonly!: boolean;
  @localCopy('args.text', null) text!: string | null;

  get classes(): string {
    return [
      this.required ? 'requiredField' : '',
      this.isReadonly ? 'cursor-default' : '',
      this.args.errors && this.args.errors.length > 0 ? 'error-description' : '',
    ]
      .join(' ')
      .trim();
  }

  <template>
    <label class={{this.classes}} for={{@for}} data-test-ui-label ...attributes>
      {{#if (has-block)}}
        {{yield}}
      {{else}}
        {{this.text}}
      {{/if}}
    </label>
  </template>
}
